import { atom } from "jotai";

import type { TaskData } from "@/types/crew/report/taskData";

export const taskDataAtom = atom<TaskData | null>(null);
taskDataAtom.debugLabel = "taskDataAtom";
